module.exports = __webpack_public_path__ + "img/group_add_opsz24.c0cb9f8f.svg";